import { Serializable } from '@/models/core/serializable';
import { SchoolGroupStudent } from '@/models/school-group/school-group-student';
import { Student } from '@/models/student/student';

export class StudentGroupingResult implements Serializable<StudentGroupingResult> {
  data: SchoolGroupStudent[] = [];
  nonCategorizedStudents: Student[] = [];

  deserialize(input: any): StudentGroupingResult {
    if (input.data && input.data.length > 0) {
      this.data = input.data.map((schoolGroupStudent: SchoolGroupStudent) => new SchoolGroupStudent().deserialize(schoolGroupStudent));
    }
    if (input.nonCategorizedStudents && input.nonCategorizedStudents.length > 0) {
      this.nonCategorizedStudents = input.nonCategorizedStudents.map((student: Student) => new Student().deserialize(student));
    }
    return this;
  }
}
